import React from "react";
import { Form } from "./form";
import styles from "./account.module.scss";
export const Account = () => {
  return (
    <div className={styles.account_container}>
      <h1 className="m-2">حساب کاربری</h1>
      <Form />
    </div>
  );
};
